import {Box, CircularProgress, Typography} from "@mui/material";
import {useAuth} from "react-oidc-context";
import {Navigate} from "react-router-dom";

const ProtectedRoute = ({children}) => {
  const auth = useAuth();

  // Mientras se carga la autenticación
  if (auth.isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          Verificando autenticación...
        </Typography>
      </Box>
    );
  }

  // Si hay un error, redirigir al login
  if (auth.error) {
    console.error("Error de autenticación:", auth.error);
    return <Navigate to="/login" replace />;
  }

  // Si no está autenticado, redirigir al login
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar que el token esté en SessionStorage
  const token = sessionStorage.getItem("token_TSE");
  if (!token && auth.user?.access_token) {
    // Si el usuario está autenticado pero el token no está en SessionStorage, guardarlo
    sessionStorage.setItem("token_TSE", auth.user.access_token);
  }

  // Si está autenticado, mostrar el contenido protegido
  return children;
};

export default ProtectedRoute;
